import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useEffect } from "react";

type Props = {
    tenant: string | undefined;
}

export async function getRceDashboardNumbers(props: Props) {
    if (!props.tenant) {
        return null;
    }

    const resp = await axios.get(`/booking/rce-dashoboard/v1/get-rce-call-center-and-fleet-team-number?tenant=${props.tenant}`)
    return resp.data;
}

export function useRceDashboardNumbersQuery(props: Props) {
    const query = useQuery({
        queryKey: ["getRceDashboardNumbers", ...Object.values(props)],
        queryFn: () => getRceDashboardNumbers(props),
    });

    return query;
}
